import React from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { FormControl, Typography } from "@material-ui/core";
import { SectionDefinition } from "api/factories/form.factory";
import { SectionDefinitionValue } from "components/SchemaProvider";
import { TextField } from "components";

export const TextFieldArray = ({ name, translation }: SectionDefinition<SectionDefinitionValue>) => {
    const { control, errors } = useFormContext();
    const { fields } = useFieldArray({
        control,
        name: `${name}_Array`,
    });

    return (
        <>
            {fields.map((field, index) => {
                return (
                    <FormControl key={field.id} fullWidth={true}>
                        <Controller
                            defaultValue={field.value}
                            name={`${name}_Array[${index}]`}
                            error={errors[`${name}_Array`]?.[index]}
                            control={control}
                            label={translation}
                            as={<TextField />}
                        />
                        {errors[name] && (
                            <Typography variant="body1" color="error">
                                {errors[name].message}
                            </Typography>
                        )}
                    </FormControl>
                );
            })}
        </>
    );
};
